// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import { DataTableData } from "@store/Library/Components/Reporting/ApiDataTable/ReportDataTable";
import TextField from "@store/MobiusOverrides/TextField/TextField";
import debounce from "lodash/debounce";
import React, { useEffect } from "react";
import styled from "styled-components";

const StyledGridContainer = styled(GridContainer)`
    && {
        margin-bottom: 1.25rem;
    }
`;
const gridWidths: GridWidths[] = [12, 9, 6, 4, 2];
interface Props {
    dataTableData: DataTableData<any>;
    setFilteredData: (data: any[]) => void;
    searchTerm: string;
    setSearchTerm: (searchTerm: string) => void;
}
const DataTableSearchForm: React.FC<Props> = ({ dataTableData, setFilteredData, searchTerm, setSearchTerm }) => {
    const { dataKeys, data } = dataTableData;

    const handleSearch: React.ChangeEventHandler<HTMLInputElement> = event => {
        setSearchTerm(event.target.value);
    };

    const searchTable = (query: string) => {
        const newData = data.filter(item => {
            return dataKeys.some(key => {
                // Some data is now coming back undefined and crashing the search so we're checking here.
                if (key in item && item[key] !== null && item[key] !== undefined) {
                    return item[key].toString().toLowerCase().includes(query.toLowerCase());
                }
                return false;
            });
        });

        setFilteredData(newData);
    };

    useEffect(() => {
        const debouncedSearchTable = debounce((query: string) => {
            searchTable(query);
        }, 300);

        debouncedSearchTable(searchTerm);
        return () => {
            debouncedSearchTable.cancel();
        };
    }, [searchTerm, dataTableData]);

    return (
        <StyledGridContainer>
            <GridItem width={gridWidths}>
                <TextField
                    style={{ borderRadius: "0.5rem" }}
                    iconProps={{ src: Search }}
                    disabled={data?.length <= 0}
                    placeholder={translate("Search")}
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </GridItem>
        </StyledGridContainer>
    );
};

export default DataTableSearchForm;
